'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TimelineLite = require('../../../../node_modules/gsap/src/uncompressed/TimelineLite');

var _TimelineLite2 = _interopRequireDefault(_TimelineLite);

var _TweenLite = require('../../../../node_modules/gsap/src/uncompressed/TweenLite');

var _TweenLite2 = _interopRequireDefault(_TweenLite);

require('../../../../node_modules/gsap/src/uncompressed/plugins/CSSPlugin');

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.transition('notification', {
    css: false,
    enter: function enter(el, done) {
        var tl = new _TimelineLite2.default({
            onComplete: done
        });

        tl.fromTo(el, .3, {
            opacity: 0,
            rotationX: -60
        }, {
            opacity: 1,
            rotationX: 60
        }).fromTo(el, .3, {
            rotationX: 60
        }, {
            rotationX: 0
        });
    },
    enterCancelled: function enterCancelled(el) {
        if (this.tl) {
            this.tl.kill();
            _TweenLite2.default.set(el, {
                opacity: 0
            });
        }
    },
    leave: function leave(el, done) {
        var tl = new _TimelineLite2.default({
            onComplete: done
        });

        tl.fromTo(el, .3, {
            opacity: 1
        }, {
            opacity: 0,
            scale: 0.3
        });
    },
    leaveCancelled: function leaveCancelled(el) {
        if (this.tl) {
            this.tl.kill();

            TweenMax.set(el, {
                opacity: 1
            });
        }
    }
});

exports.default = {
    props: {
        type: {
            default: 'info'
        },
        show: {
            default: false
        }
    },
    ready: function ready() {
        var _this = this;

        setTimeout(function () {
            return _this.show = false;
        }, 3000);
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"notification notification--{{ type }}\" transition=\"notification\" v-show=\"show\">\n    <slot></slot>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-1528a4d9", module.exports)
  } else {
    hotAPI.update("_v-1528a4d9", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}